import { render } from "./EditMarquee.vue?vue&type=template&id=0c9ba924"
import script from "./EditMarquee.vue?vue&type=script&lang=js"
export * from "./EditMarquee.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__